import { useCopyToClipboard } from '@/lib/hooks'
import s from '@/shared/components/CopyBlock.module.css'

interface CopyBlockProps {
  value: string
}

/** A token/secret box with an overlaid ghost copy button (✓ on copy),
 *  matching the copy affordance used in AccessTokenModal. */
export function CopyBlock({ value }: CopyBlockProps) {
  const { copy, copied } = useCopyToClipboard()
  return (
    <div className={s.wrap}>
      <div className={s.box}>{value}</div>
      <button
        type="button"
        className={s.copyOverlay}
        onClick={() => copy(value)}
        aria-label={copied ? 'Copied' : 'Copy'}
        title={copied ? 'Copied' : 'Copy'}
      >
        {copied ? (
          <span className={s.copyTick}>✓</span>
        ) : (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
        )}
      </button>
    </div>
  )
}
